/** Centered content cap shared by the Products/ProductView/ProjectView main views. */
export const MAIN_CONTENT_WIDTH = 'mx-auto w-full max-w-[1400px]';
